/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * When student started working on the module
 */
export type StudentProgressRecordModuleStartDate = string | null;
